module.exports = "/_next/static/images/a25a9e7c0ee5afcd09ce698e591448a1-missing-info.svg.webp";